import axios from "axios";
import React, { useEffect, useState } from "react";
import styled from "styled-components";

function CourseInnerContent(props) {
  const { courseId, lectureId, refreshKey, onCompletionChange } = props;

  const [user] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("user")) || null;
    } catch {
      return null;
    }
  });

  const [isFinished, setIsFinished] = useState(false);

  useEffect(() => {
    if (!lectureId) return;
    if (typeof onCompletionChange === "function") {
      onCompletionChange(lectureId, isFinished);
    }
  }, [isFinished, lectureId, onCompletionChange]);

  useEffect(() => {
    if (!courseId || !lectureId || !user?.email) return;

    // cancel in-flight request if props change/unmount
    const controller = new AbortController();

    (async () => {
      try {
        const { data } = await axios.post(
          "/extractUserCourseInfo",
          { courseId, lectureId, userEmail: user.email },
          { signal: controller.signal }
        );

        if (data && typeof data.isFinished === "boolean") {
          setIsFinished(data.isFinished);
        } else {
          setIsFinished(Boolean(data));
        }
      } catch (err) {
        if (err.name !== "CanceledError" && err.name !== "AbortError") {
          // network/other error → treat as not finished
          setIsFinished(false);
        }
      }
    })();

    return () => controller.abort();
  }, [courseId, lectureId, user?.email, refreshKey]);

  return (
    <Container>
      { isFinished ? ( <FilledCircle/> ) : ( <EmptyCircle /> )}
    </Container>
  );
}

export default CourseInnerContent;

const Container = styled.div`
  margin-right: 5px;
`;

const FilledCircle = styled.div`
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 2px solid #5fb05f;
  background: radial-gradient(
    circle,
    #5fb05f 51%,
    transparent 52%
  );
  box-sizing: border-box;
`;
const EmptyCircle = styled.div`
  height: 16px;
  width: 16px;
  border: 2px solid black;
  border-radius: 50%;
`;


